module.exports = __webpack_public_path__ + "img/picture_viptk02n.5315bec4.png";